var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpandSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 448,
    viewBox: "0 0 448 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.3 0 0 14.3 0 32V128C0 145.7 14.3 160 32 160C49.7 160 64 145.7 64 128V64H128C145.7 64 160 49.7 160 32C160 14.3 145.7 0 128 0H32ZM64 320C64 302.3 49.7 288 32 288C14.3 288 0 302.3 0 320V416C0 433.7 14.3 448 32 448H128C145.7 448 160 433.7 160 416C160 398.3 145.7 384 128 384H64V320ZM320 0C302.3 0 288 14.3 288 32C288 49.7 302.3 64 320 64H384V128C384 145.7 398.3 160 416 160C433.7 160 448 145.7 448 128V32C448 14.3 433.7 0 416 0H320ZM448 320C448 302.3 433.7 288 416 288C398.3 288 384 302.3 384 320V384H320C302.3 384 288 398.3 288 416C288 433.7 302.3 448 320 448H416C433.7 448 448 433.7 448 416V320Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandSolid);
export default __webpack_public_path__ + "static/media/expand-solid.b4b1e8c71156b331571b227f7097ddb0.svg";
export { ForwardRef as ReactComponent };